import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { vendorsApi, UpdateVendorDto } from "../../../api/vendors";
import { notifications } from "@mantine/notifications";

export function useVendorProfile() {
  return useQuery({
    queryKey: ["vendor", "profile"],
    queryFn: () => vendorsApi.getProfile(),
  });
}

export function useUpdateVendorProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateVendorDto) => vendorsApi.updateProfile(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendor", "profile"] });
      queryClient.invalidateQueries({ queryKey: ["vendor-profile-ready"] });
      notifications.show({
        title: "Success",
        message: "Profile updated successfully",
        color: "green",
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: "Error",
        message: error.response?.data?.error || "Failed to update profile",
        color: "red",
      });
    },
  });
}

